/*
 * Filename: onLoad-set-value-rule.controller.ts
 * Description: Controller for onload set value rule
 */

import { CQAppConstant } from '../../../app-constants';
import { ICriteria } from '../../../components/template-configuration/layout-configuration-panel/ILayoutConfigurationPanel.Interface';
import { FormRuleController } from '../form-rule.controller';
import { ISetValueRuleObject } from '../IRules.interface';

export class CQOnLoadSetValueRuleController extends FormRuleController {
    // public targetFieldApiName = '';
    // public fields: string[] = [];
    // public filter = '';
    public ruleJSON = {};

    constructor(ruleObject: any) {
        super();
        this.formRuleJson(ruleObject.setValues);
    }

    /**
     * @private
     * @memberof CQOnLoadSetValueRuleController
     */
    private formRuleJson = (setValueRuleData: ISetValueRuleObject[]) => {
        
        const setValueRule = this.formRuleFilter(setValueRuleData);
        const componentRule = CQAppConstant.COMPONENT_EVENT_RULES_MAP;
        this.ruleJSON = {
            [componentRule.onLoadsetValues.key]: { onLoad: { 'setValues': setValueRule } }
        };

        return this.formRuleJson;
    }

    /**
    * @memberof CQOnLoadSetValueRuleController
    */
    public formRuleFilter = (setValueRuleData: ISetValueRuleObject[]) => {
        const setValues: any[] = [];
        setValueRuleData.forEach((setValueSection) => {
            const fields: string[] = [];
            const setValuesObject = { fields, filter: '', action: {} };
            setValueSection.addedCriterias.forEach((criteria: ICriteria) => {
                if(!criteria.field.includes('-') && !setValuesObject.fields.includes(criteria.field)){
                    setValuesObject.fields.push(criteria.field);
                }
                
                if (criteria.isDynamic
                    && criteria.operator !== CQAppConstant.EXISTS
                    && criteria.operator !== CQAppConstant.ISEMPTY) {
                    if(!criteria.compareTo.includes('-') && !setValuesObject.fields.includes(criteria.compareTo)){
                        setValuesObject.fields.push(criteria.compareTo);
                    }
                }
            });

            if(setValueSection.shouldSkip){
                setValuesObject.filter = "true";
            }else{
                setValuesObject.filter = this.formFilterString(setValueSection.complexLogicQuery, setValueSection.addedCriterias);
            }
            
            setValueSection.actions.map((action: any) => {
                action.compareTo = this.covertActionValueStringIfIBooleanType(action.compareTo);
                return action;
            });
            const actionObj = setValueSection.actions.reduce(function (o: any, action: any) {
                const dynamicValueItem = CQAppConstant.SETVALUE_RULE_DYNAMIC_SOURCE_VALUES.filter(item => item.label === action.compareTo);
                const key = action.field;
                if (dynamicValueItem.length !== 0 && dynamicValueItem[0].isSupportedFunction) {
                    o[key] =  action.compareTo === 'AddDays()'?{ 'fx': `${dynamicValueItem[0].value}`, 'value': parseInt(action.supportedFunctionValue) }:{ 'fx': `${dynamicValueItem[0].value}`};
                } else if (dynamicValueItem.length !== 0 && !dynamicValueItem[0].isSupportedFunction) {
                    o[key] = dynamicValueItem[0].value;
                }
                else {
                    // const isNumber = !isNaN(parseFloat(action.compareTo)) && isFinite(parseInt(action.compareTo));
                    let isNumber = false;
                    if (action.compareTo === true || action.compareTo === false || action.compareTo === '') {
                        isNumber = false;
                    } else {
                        isNumber = !isNaN(action.compareTo);
                    }
                    const value = isNumber ? parseInt(action.compareTo) : action.compareTo;
                    o[key] = value;
                }
 
                return o;
            }, {});

            setValuesObject.action = actionObj;
            setValues.push(setValuesObject);
        });

        return setValues;
    }

    /**
     * @memberof CQOnLoadSetValueRuleController
     */
    public formStateJson = () => {
        //state management logic here
    }
}

